module.exports = __webpack_public_path__ + "img/circle2.8b5de3f7.svg";